import * as Utils from '@ext/index';



export class Tipos {

    constructor( id: string ) {
        this.Id = id;
    }

    public readonly Id: string;

    public static toTipo( id: string ): Tipos {

        if ( id === this.Texto.Id )
            return this.Texto;
        else if ( id === this.Archivo.Id )
            return this.Archivo;

        return new Tipos( id );
    }

    public static readonly Texto: Tipos = new Tipos( 'texto' );
    public static readonly Archivo: Tipos = new Tipos( 'archivo' );

    public static Options: Array<Tipos> = [
        Tipos.Texto,
        Tipos.Archivo,
    ];


    public get esTexto(): boolean { return this.Id === Tipos.Texto.Id; }
    public get esArchivo(): boolean { return this.Id === Tipos.Archivo.Id; }
}


export class Estados {

    constructor( id: string ) {
        this.Id = id;
    }

    public readonly Id: string;

    public static toTipo( id: string ): Estados {

        if ( id === this.Enviado.Id )
            return this.Enviado;
        else if ( id === this.Enviando.Id )
            return this.Enviando;
        else if ( id === this.Leido.Id )
            return this.Leido;
        else if ( id === this.Recibido.Id )
            return this.Recibido;

        return new Estados( id );
    }

    public static readonly Enviando: Estados = new Estados( 'enviando' );
    public static readonly Enviado: Estados = new Estados( 'enviado' );
    public static readonly Leido: Estados = new Estados( 'leido' );
    public static readonly Recibido: Estados = new Estados( 'recibido' );

    public static Options: Array<Estados> = [
        Estados.Enviando,
        Estados.Enviado,
        Estados.Leido,
        Estados.Recibido,
    ];


    public get esEnviando(): boolean { return this.Id === Estados.Enviando.Id; }
    public get esEnviado(): boolean { return this.Id === Estados.Enviado.Id; }
    public get esLeido(): boolean { return this.Id === Estados.Leido.Id; }
    public get esRecibido(): boolean { return this.Id === Estados.Recibido.Id; }
}